import {repeatOptions, timeWindowOptions} from "./ToDos.js";
import {useContext, useEffect, useState} from "react";
import SelectWeex from "./elements/SelectWeex.js";
import Select2Weex from "./elements/Select2Weex.js";
// @ts-ignore
import {APIContext} from "./Globals.tsx";
// @ts-ignore
import {CourseTypeDTO} from "./model/CourseTypeDTO.tsx";

type Props = {
  onSave: (data: CourseTypeDTO) => void, defaults: CourseTypeDTO, setCourseType: (data: CourseTypeDTO) => void
};

export default function Defaults({
                                   onSave, defaults, setCourseType: setCourseTypes
                                 }: Props){
  const [coaches, setCoaches] = useState<{ id: string, value: string, label: string }[]>();
  const [locations, setLocations] = useState<{ id: string, value: string, label: string }[]>();
  const {fetchLocations, fetchCoaches} = useContext(APIContext)

  useEffect(() => {
    fetchLocations().then(ans => {
      let locations_ = ans?.locations?.map(a => {
        return ({
          id: a.id, value: a.name, label: a.name
        });
      })
      setLocations(locations_);
    });

    fetchCoaches().then(ans => {
      let coaches_ = ans?.persons?.map(a => {
        return ({
          id: a.id, value: a.firstname + " " + a.lastname, label: a.firstname + " " + a.lastname
        });
      })
      setCoaches(coaches_);
    });
  }, []);

  function callOnSave(){
    onSave(defaults);
  }

  return (<div className={"card addCourse"}>
    <h4 style={{margin: 0}}>Standardwerte</h4>
    <SelectWeex placeholder={"Ort"} value={locations?.find(location => defaults.defaultLocation == location.id)}
                options={locations ?? []} onChange={(e) => {
      let edit = defaults
      edit.defaultLocation = e?.id ?? null
      setCourseTypes(edit)
    }}/>
    <SelectWeex placeholder={"Kein Coach zugewiesen"} value={coaches?.find(coach => defaults.defaultCoach == coach.id)} options={coaches ?? []}
                onChange={(e) => {
                  let edit = defaults
                  edit.defaultCoach = e?.id ?? null
                  setCourseTypes(edit)
                }}/>
    <div>
      <Select2Weex label={"Anmeldung bis"} placeholder={"xy min vorher"}
                   options={timeWindowOptions} onChange={(e) => {
        let edit = defaults
        edit.defaultSignInWindow = e?.value ?? null
        setCourseTypes(edit)
      }} value={timeWindowOptions?.find(time => defaults.defaultSignInWindow?.toString() == time.value)}
                   defaultInputValue={undefined} isMulti={undefined} containerStyle={undefined}/>
      <Select2Weex label={"Abmeldung bis"} placeholder={"xy min vorher"}
                   options={timeWindowOptions} onChange={(e) => {
        let edit = defaults
        edit.defaultSignOutWindow = e?.value ?? null
        setCourseTypes(edit)
      }} value={timeWindowOptions?.find(time => defaults.defaultSignOutWindow?.toString() == time.value)}
                   defaultInputValue={undefined} isMulti={undefined} containerStyle={undefined}/>
      <Select2Weex label={"Wiederholung"} placeholder={"Wöchentlich"}
                   options={repeatOptions} isMulti={true} onChange={(e) => {
        let edit = defaults
        edit.defaultRepeat = e?.map(options=>options.value) ?? null
        setCourseTypes(edit)
      }} value={repeatOptions?.filter(time => defaults.defaultRepeat?.includes(time.value))}
                   defaultInputValue={undefined} containerStyle={undefined}/>
    </div>
    <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: "5%"}}>
      <button className={"primarybutton"} onClick={callOnSave}>Speichern</button>
    </div>
  </div>);
}